var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 177,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#28303F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.553 163.215c1.91-1.47 2.95-2.92 5.49-.8 1.38 1.15 3.19 4.08 4.1 5.61 2.29 3.84 1.4 6.75.45 7.68-1.58 1.54-8.69-.08-12.21-7.41-1.4-2.91.7-5.37 2.48-6.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M67.553 163.215c1.91-1.47 2.95-2.92 5.49-.8 1.38 1.15 3.19 4.08 4.1 5.61 2.29 3.84 1.4 6.75.45 7.68-1.58 1.54-8.69-.08-12.21-7.41-1.4-2.91.7-5.37 2.48-6.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M68.473 166.624c-1.25-4.5-4.11-13.61-6.4-16.22-.86-.98-1.02-2.38-.37-3.14.65-.76 1.88-.57 2.74.41 3.51 4.01 5.8 13.09 6.49 14.86-2.79 1.05-2.45 4.09-2.45 4.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M68.473 166.624c-1.25-4.5-4.11-13.61-6.4-16.22-.86-.98-1.02-2.38-.37-3.14.65-.76 1.88-.57 2.74.41 3.51 4.01 5.8 13.09 6.49 14.86-2.79 1.05-2.45 4.09-2.45 4.09h-.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M74.895 164.534c-2.66-4.47-7.89-.98-6.05 3.57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.77,
    d: "M134.024 87.113c-4.89 5.3-17.98 17.04-23.54 18.58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.245 81.524c.5.19 1 .38 1.41.72.41.34.71.85.66 1.38-.06.56-.5 1.02-1 1.3s-1.05.42-1.57.66c-.87.41-1.61 1.11-2.2 1.87-.06.48-.61.71-1.09.8-.48.09-1.02.15-1.29.56-.13.21-.17.47-.31.67-.19.27-.56.37-.89.34-.33-.03-.64-.18-.94-.33-.78-.38-1.56-.77-2.24-1.29-.68-.52-1.28-1.21-1.55-2.03-.26-.77-.23-1.6-.28-2.41-.12-1.98-.74-4.05-.03-5.9.11-.29.28-.6.58-.69.39-.13.78.16 1.06.44.46.47.86 1.01 1.17 1.59.07.13.14.27.27.32.17.07.37-.04.47-.2.1-.16.12-.35.15-.53.17-1.12.7-2.18 1.48-2.99.33-.34.72-.65 1.19-.7.74-.08 1.41.56 1.64 1.27.23.71.13 1.48.06 2.23-.03.25.02.59.27.61.11 0 .21-.06.3-.12l1.42-1c.49-.35 1.05-.71 1.65-.62.6.09 1.05.66 1.13 1.26.08.6-.16 1.21-.52 1.7s-.84.87-1.02 1.1l.02-.01Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M136.784 87.915c.07.31.14.64.09.96-.05.32-.24.64-.54.74-.19.07-.41.04-.61 0-1.42-.25-3.45-1.44-4.47-2.46-.22-.22-.43-.47-.53-.77-.1-.3-.04-.66.1-1 .12-1.99.03-3.99-.26-5.96-.06-.43-.14-.87-.04-1.3.1-.43.42-.83.85-.89.39-.05.76.19 1.05.44a5.39 5.39 0 0 1 1.68 2.72c.5-1.55 1.02-3.13 1.98-4.44.38-.51.89-1.02 1.53-1.04.74-.03 1.38.63 1.54 1.35.16.72.02 1.24-.34 1.89-.23.43-.41 1.02-1.02 1.81.95-.88 2.16-1.62 3.58-2.2.43-.18.88-.36 1.35-.33.47.03.94.28 1.13.71.26.61-.15 1.29-.59 1.79-1.09 1.23-2.47 2.14-3.84 3.04.74-.51 1.61-.9 2.51-.9.9 0 1.84.46 2.24 1.27.16.34.19.75-.02 1.07-.49.74-1.62 1.06-1.84 1.14-2.23.82-3.02 3.75-5.55 2.34l.02.02Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M109.453 155.733c1.41-1.99 1.98-3.67 5.13-2.54 1.71.61 4.4 2.75 5.77 3.87 3.16 2.59 3.7 5.3 3.09 6.57-.82 1.71-8.49 3.46-14.52-2.48-2.28-2.25-.99-5.22.42-6.76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M109.453 155.733c1.41-1.99 1.98-3.67 5.13-2.54 1.71.61 4.4 2.75 5.77 3.87 3.16 2.59 3.7 5.3 3.09 6.57-.82 1.71-8.49 3.46-14.52-2.48-2.28-2.25-.99-5.22.42-6.76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M111.175 158.405c-3.08-4.19-6.61-7.77-9.98-9.78-1.26-.75-1.99-2.12-1.63-3.06.36-.94 1.67-1.09 2.93-.33 5.17 3.08 7.73 6.94 9.14 8.54-2.41 1.81-.47 4.63-.47 4.63"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M111.175 158.405c-3.08-4.19-6.61-7.77-9.98-9.78-1.26-.75-1.99-2.12-1.63-3.06.36-.94 1.67-1.09 2.93-.33 5.17 3.08 7.73 6.94 9.14 8.54-2.41 1.81-.47 4.63-.47 4.63h.01Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M115.995 153.895c-3.59-2.47-6.99 1.8-4.13 5.71"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.214 97.606s-8.19-16.23-22.57-18.33c-7.99-1.17-11.67 6.19-6.63 13.34 6.53 9.27 29.21 4.99 29.21 4.99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M61.294 111.184s-3.59-20.91-15.4-29.39c-6.56-4.71-16.07-2.88-15.31 5.83 1.15 13.21 30.71 23.55 30.71 23.55v.01Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M55.713 98.503s-26.4 3.22-24.84-14.3M29.223 76.414c2.25-2.6 5.77-4.05 9.21-3.78M24.742 75.045c1.03-1.95 3.42-3.86 6.14-4.9M135.604 107.465c-3.64.6-7.28 1.19-10.92 1.79M127.574 55.402c-2.61 2.61-5.21 5.22-7.82 7.83M36.124 112.605c-3.49.27-6.99.53-10.48.8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    d: "M56.593 97.054s-6.19 9.05-6.92 23.08c-1.59 30.82 21.67 33.94 33.09 33.39 10.68-.51 31.95-5.71 30.56-34.76-.34-7.13-3.27-17.16-9.97-24.19"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M56.593 97.054s-6.19 9.05-6.92 23.08c-1.59 30.82 21.67 33.94 33.09 33.39 10.68-.51 31.95-5.71 30.56-34.76-.34-7.13-3.27-17.16-9.97-24.19"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.745 126.555c15.89-.82 28.93-11.63 31.1-15.59l-3.72-8.02c-4.96 7.42-14.59 12.45-27.84 13.13-12.07.62-23.6-3.45-29.55-10.28l-1.93 8.83c3.6 4.81 17.44 12.68 31.94 11.93Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.374 144.444c15.89-.82 27.43-10.64 29.6-14.6l1.73-11.16c-4.96 7.42-18.39 14.81-31.79 15.27-15.58.54-26.89-5.12-32.84-11.95l2.22 10.91c3.6 4.81 16.58 12.27 31.08 11.52M111.723 76.654c1.34-18.92-14.26-29.33-32.7-29.33-18.44 0-39.16 13.32-33.47 36.64 2 8.21 7.6 13.16 17.45 17.03 1.38.54 6.72-.87 6.72-.87 1.54-.37 3.32 2.36 5.12 1.63 14.45-5.88 35.55-21.91 35.55-21.91l2.15-3.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.43,
    d: "M111.723 76.654c1.34-18.92-14.26-29.33-32.7-29.33-18.44 0-39.16 13.32-33.47 36.64 2 8.21 7.6 13.16 17.45 17.03 1.38.54 6.72-.87 6.72-.87 1.54-.37 3.32 2.36 5.12 1.63 14.45-5.88 35.55-21.91 35.55-21.91l2.15-3.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    d: "M112.462 83.545c-1.86 10.74-8.4 16.71-17.94 19.43-8.65 2.47-29.49 2.68-41.71-7.52-.54-.45-2.11-2.06-1.83-2.32.29-.27 2.65-2.26 3.43-3.58 1.35-2.28 1.56-4.72 1.03-8.65-.93-6.84 2.54-16.83 12.18-21.34 7.03-3.28 16.65-2.19 25.12 1.66 2.64 1.2 4.28 2.67 6.93 2.02 2.06-.51 3.53-4.63 4.91-5.62 1.04-.74 3.97 3.43 5.42 6.83 1.17 2.74 4.09 9.69 2.47 19.1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.43,
    d: "M112.462 83.545c-1.86 10.74-8.4 16.71-17.94 19.43-8.65 2.47-29.49 2.68-41.71-7.52-.54-.45-2.11-2.06-1.83-2.32.29-.27 2.65-2.26 3.43-3.58 1.35-2.28 1.56-4.72 1.03-8.65-.93-6.84 2.54-16.83 12.18-21.34 7.03-3.28 16.65-2.19 25.12 1.66 2.64 1.2 4.28 2.67 6.93 2.02 2.06-.51 3.53-4.63 4.91-5.62 1.04-.74 3.97 3.43 5.42 6.83 1.17 2.74 4.09 9.69 2.47 19.1l-.01-.01Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.43,
    d: "M96.043 84.745a8.342 8.342 0 0 0-1.22 3.48c-.08.72-.03 1.55.53 2.01.48.39 1.19.37 1.74.09s.96-.77 1.3-1.28c.79-1.18 1.32-2.51 1.81-3.85.24-.65.46-1.4.1-1.99-.37-.6-1.22-.74-1.89-.5-.67.24-1.45.55-2.38 2.04h.01Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M105.873 71.664c-.89 1.06-1.66 2.21-2.32 3.42 2.01-.67 4.14-.97 6.26-.88M82.623 73.375c1.68 1.08 3.22 2.39 4.54 3.89-3.15-.9-6.54-.93-9.71-.08"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.77,
    d: "M30.543 90.535c4.6 5.54 18.16 16.69 22.87 20.65"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.033 89.334c-.35.4-.7.81-.9 1.3-.2.49-.22 1.09.07 1.53.32.47.93.66 1.49.67.56.01 1.13-.13 1.69-.16.97-.05 1.95.21 2.82.6.28.39.88.34 1.34.18.46-.15.97-.35 1.4-.12.22.12.37.33.59.44.3.15.67.06.94-.13.27-.19.47-.47.67-.74.5-.7 1.01-1.41 1.36-2.2.35-.79.55-1.67.41-2.52-.14-.8-.56-1.51-.9-2.25-.83-1.8-1.27-3.91-2.77-5.21-.24-.2-.53-.39-.84-.33-.4.07-.61.51-.72.9-.19.63-.28 1.29-.27 1.95 0 .14 0 .3-.09.41-.12.14-.35.14-.51.05-.16-.09-.27-.25-.38-.4-.68-.9-1.65-1.58-2.72-1.93-.45-.14-.95-.23-1.38-.05-.69.29-.98 1.16-.84 1.9s.59 1.37 1.01 1.99c.14.2.26.53.05.66-.09.06-.21.05-.32.04-.58-.07-1.15-.14-1.73-.2-.6-.07-1.26-.12-1.74.24-.48.37-.61 1.08-.4 1.65.21.57.71.99 1.26 1.25s1.15.37 1.42.49l-.01-.01Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M27.864 92.376c.09.31.18.63.37.89s.51.45.83.4c.2-.03.38-.16.54-.28 1.13-.9 2.36-2.9 2.77-4.29.09-.3.16-.62.1-.93-.06-.31-.28-.6-.57-.83-1.05-1.69-1.92-3.5-2.6-5.37-.15-.41-.29-.83-.58-1.16-.29-.33-.76-.53-1.17-.38-.37.14-.58.52-.71.89a5.457 5.457 0 0 0-.19 3.2c-1.18-1.12-2.38-2.27-3.85-2.97-.58-.27-1.27-.47-1.84-.19-.67.32-.91 1.21-.71 1.92.2.71.7 1.34 1.33 1.74.41.27.72.47 1.62.87-1.25-.33-2.67-.4-4.2-.24-.46.05-.94.11-1.34.35-.4.24-.7.69-.66 1.16.06.66.74 1.06 1.37 1.29 1.54.56 3.19.71 4.82.86-.9-.1-1.85-.03-2.64.4-.79.43-1.4 1.28-1.36 2.18.02.38.19.75.52.93.78.42 1.93.17 2.16.13 2.35-.33 4.44 1.86 6-.58l-.01.01ZM31.514 41.195c3.43 4.09 6.87 8.18 10.3 12.26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.86,
    d: "M103.333 47.363s-1.76 2.95-4.29 4.63"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M102.994 46.733s4.64-2.52 6.03-3.75c1.04-.91 2.61-2.33 3.34-3 .21-.19.63-.17.79.03.61.77 1.46 2.57-1.41 4.84-3.37 2.67-7.73 2.75-7.73 2.75l-1.03-.88.01.01Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.86,
    d: "M71.353 42.035s.67 3.37-.08 6.31"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.43,
    d: "M70.684 41.804s1.74-4.98 1.96-6.83c.16-1.37.37-3.48.46-4.46.03-.29.35-.55.61-.51.97.16 2.81.93 2.2 4.54-.71 4.24-3.88 7.23-3.88 7.23l-1.35.04v-.01Z"
  })));
};
export default SvgError;